<template>
  <node-view-wrapper class="editor-wrapper-std">
    <div class="label" contenteditable="false">Flex-контейнер</div>

    <div class="close" contenteditable="false" @click="rowSettings">
      <v-icon>mdi-cog</v-icon>
    </div>

    <node-view-content class="content-dom d-flex flex-wrap" />

    <div class="editor-wrapper-std__controls" contenteditable="false">
      <v-btn depressed outlined class="mr-4" @click="addColumn"
        >Добавить flex-элемент</v-btn
      >
    </div>

    <row-settings-dialog
      v-model="settingsDialog"
      :classes="classes"
      @apply="setSettings"
      @close="closeSettings"
    />
  </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper, NodeViewContent } from "@tiptap/vue-2";
import RowSettingsDialog from "./FlexSettings/RowSettingsDialog.vue";

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent,
    RowSettingsDialog
  },
  props: nodeViewProps,
  data() {
    return {
      settingsDialog: false,
      classes: ""
    };
  },
  methods: {
    addColumn() {
      const endPos = this.getPos() + this.node.nodeSize - 1;
      this.editor
        .chain()
        .focus("start")
        .insertContentAt(endPos, '<div class="aunfcol col"><p></p></div>')
        .run();
    },
    rowSettings() {
      this.classes = this.node.attrs.class;
      this.settingsDialog = true;
    },
    closeSettings() {
      this.settingsDialog = false;
    },
    setSettings(value) {
      const v = value.join(" ");
      this.updateAttributes({
        class: "aunfrow row" + (v.length ? ` ${v}` : "")
      });
    }
  }
};
</script>
